export default __webpack_public_path__ + "static/Plots0011-0d7ddf3c662bc8249e28279d50abd2ce.jpg";